export const adults = [
    { name: "Adulte", quantity: 0, key: "adult" },
    { name: "Enfant (-12 ans)", quantity: 0, key: "child" },
    { name: "Bébé (-2 ans)", quantity: 0, key: "child1" },
    {
        name: "Animal",
        quantity: 0,
        key: "animal"
    }
];
export const currencies = [
    {
        code: "EUR",
        symbol: "€"
    },
    {
        code: "MAD",
        symbol: "DH"
    }
];
export const OPTIONS = {
    checkbox: 1,
    image: 2
};
export const siteKey = "6Le3CqUZAAAAACDNeJ2am-FNSx8541Ro-5yZqtlL";
